export var PaymentProviderType;
(function (PaymentProviderType) {
    PaymentProviderType["PINCH"] = "pinch";
})(PaymentProviderType || (PaymentProviderType = {}));
export const paymentProviderConfig = {
    [PaymentProviderType.PINCH]: {
        enabledAccountingSystems: [`XERO`, `QBO`],
    },
};
//# sourceMappingURL=paymentProviders.js.map